// Common types used across the application

export interface ProfilePhotoUrls {
  original: string;
  thumbnail: string;
  small: string;
  medium: string;
  large: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  nickname?: string;
  bio?: string;
  profile_photo_urls?: ProfilePhotoUrls; // Structured photo URLs
}

export interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
}

export enum LoadingStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export interface BaseState<T> {
  data: T | null;
  status: LoadingStatus;
  error: string | null;
}